<template>
  <div class="cruxEvent">
    <a-collapse v-model:activeKey="activeKey" :expandIconPosition="expandIconPosition">
      <a-collapse-panel key="1" :header="title">
        <div class="criticalIncidentSlot" v-if="data.length">
          <div v-for="(item, index) in data" :key="index" class="item" >
           <div v-if="item.team === 1">
             <div class="icon flex">
               <img :src="(eventLegendIcon[item.typeId] || eventLegendIcon.default).src" alt="">
               <span class="time">{{ formatMatchMinute(item.occurTime, item.overTime) }}</span>
             </div>
             <div class="score">{{item.playerName}}</div>
             <div class="center">{{item.content}}</div>
           </div>

            <div class="right" v-else>
              <div class="center">{{item.content}}</div>
              <div class="score">{{item.playerName}}</div>
              <div class="icon flex">
                <img :src="(eventLegendIcon[item.typeId] || eventLegendIcon.default).src" alt="">
                <span class="time">{{ formatMatchMinute(item.occurTime, item.overTime) }}</span>
              </div>
            </div>
          </div>
        </div>
        <template #extra>
          <SettingOutlined @click="handleClick"/>
        </template>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>


<script setup lang="ts">
import { ref } from "vue";
import { SettingOutlined } from '@ant-design/icons-vue'
import { eventLegendIcons } from '@/utils/imageUtils'

// 定义组件属性
const props = defineProps({
  data: {
    type: Array,
    required: true
  },
  title: {
    type: String,
    required: true
  }
})

const activeKey = ref(['1']);
const expandIconPosition = ref('right');

const handleClick = (event: MouseEvent) => {
  event.stopPropagation();
};

const formatMatchMinute = (occurTime?: number, overTime?: number) => {
  if (typeof occurTime !== 'number' || Number.isNaN(occurTime)) return ''
  const minute = Math.max(0, Math.round(occurTime / 60))
  if (typeof overTime === 'number' && overTime > 0) return `${minute}+${overTime}'`
  return `${minute}'`
}

// 使用统一的图片引入方案
const eventLegendIcon = eventLegendIcons


</script>

<style scoped lang="scss">
.cruxEvent {
  :deep(.ant-collapse) {
    border: none;
    background: transparent;

    .ant-collapse-item {
      border: 1px solid $border-color;
      border-radius: 14px;
      overflow: hidden;
      background: $bg-white;
      box-shadow: 0 10px 30px rgba(17, 24, 39, 0.06);
    }

    .ant-collapse-item + .ant-collapse-item {
      margin-top: 12px;
    }
  }

  :deep(.ant-collapse-header) {
    padding: 14px 14px !important;
    background: linear-gradient(180deg, rgba($color-primary, 0.14) 0%, rgba($color-primary, 0.06) 100%);
    color: $text-dark;
    font-weight: 700;
    text-align: left;
    align-items: center;
  }

  :deep(.ant-collapse-header:hover) {
    background: linear-gradient(180deg, rgba($color-primary, 0.18) 0%, rgba($color-primary, 0.08) 100%);
  }

  :deep(.ant-collapse-header-text) {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  :deep(.ant-collapse-header-text::before) {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 999px;
    background: $color-primary;
    box-shadow: 0 0 0 4px rgba($color-primary, 0.16);
  }

  :deep(.ant-collapse-expand-icon) {
    display: flex;
    align-items: center;
  }

  :deep(.ant-collapse-arrow) {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }

  :deep(.ant-collapse-item-active .ant-collapse-arrow) {
    color: $color-primary;
  }

  :deep(.ant-collapse-extra) {
    display: flex;
    align-items: center;
    margin-inline-start: 10px;
  }

  :deep(.ant-collapse-extra .anticon) {
    color: rgba(0, 0, 0, 0.45);
    font-size: 16px;
    padding: 6px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.04);
    transition: background-color 0.18s ease, color 0.18s ease, transform 0.18s ease;
  }

  :deep(.ant-collapse-extra .anticon:hover) {
    color: $color-primary;
    background: rgba($color-primary, 0.12);
    transform: translateY(-1px);
  }

  :deep(.ant-collapse-content) {
    border-top: none;
    background: $bg-white;
  }

  :deep(.ant-collapse-content-box) {
    padding: 12px 14px 14px;
  }

  .flex {
    display: flex;
    justify-content: left;
  }

  .criticalIncidentSlot {
    .item {
      & > div {
        display: grid;
        grid-template-columns: 84px 120px 1fr;
        gap: 10px;
        align-items: center;
        padding: 10px 12px;
        margin-bottom: 10px;
        border-radius: 12px;
        background: $bg-stripe;
        border: 1px solid $border-light;
      }

      .right {
        grid-template-columns: 1fr 120px 84px;
      }

      .icon {
        align-items: center;
        gap: 8px;
        color: $text-secondary;

        img {
          width: 16px;
          height: 16px;
        }

        .time {
          font-weight: 700;
          font-size: 12px;
          color: $text-dark;
          padding: 2px 8px;
          border-radius: 999px;
          background: rgba(0, 0, 0, 0.05);
        }
      }

      .score {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-family: PingFang SC, PingFang SC;
        font-weight: 700;
        font-size: 12px;
        color: $text-dark;
      }

      .center {
        font-weight: 400;
        font-size: 12px;
        color: $text-primary;
        line-height: 1.45;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .statistics {
    width: 408px;
    height: 300px;
    background: $bg-stripe;
    border-radius: 8px 8px 8px 8px;
  }
}
</style>
